export default process.env.NODE_ENV != "production" ? {
  node_api_endpoint: 'http://localhost:4004/v1',
  // node_api_endpoint: 'https://pgportalapi.escrowstack.io/v1',
  // node_api_endpoint: 'https://simportalapi.myground11.co.in/v1',
  firebaseConfig: {
    apiKey: "AIzaSyDOem_OSJJlrWk1xdxZJwT262Xuf20SoLI",
    authDomain: "phedora-payouts.firebaseapp.com",
    projectId: "phedora-payouts",
    storageBucket: "phedora-payouts.appspot.com",
    messagingSenderId: "342415860715",
    appId: "1:342415860715:web:64c1d9d725f4ace5512fae",
    measurementId: "G-87QEYBXN8Y"
  } 
} : {
  node_api_endpoint: 'https://portalapiescb.escrowstack.io/v1',
   //'https://portalindapi.escrowstack.io/v1',
  // node_api_endpoint: 'https://pgportalapi.escrowstack.io/v1/',
  // node_api_endpoint: 'https://portalnsdl.escrowstack.io/v1',
  // node_api_endpoint: 'https://simportalapi.myground11.co.in/v1',
  node_api_admin_endpoint: `http://localhost:3002`,
  firebaseConfig: {
    apiKey: "AIzaSyDOem_OSJJlrWk1xdxZJwT262Xuf20SoLI",
    authDomain: "phedora-payouts.firebaseapp.com",
    projectId: "phedora-payouts",
    storageBucket: "phedora-payouts.appspot.com",
    messagingSenderId: "342415860715",
    appId: "1:342415860715:web:64c1d9d725f4ace5512fae",
    measurementId: "G-87QEYBXN8Y"
  } 
}